import Typography, { TypographyProps } from "ds/components/Typography";

const PageWrapperTitle = (props: Omit<TypographyProps, "variant" | "tag">) => {
  return <Typography {...props} tag="h2" />;
};

export default PageWrapperTitle;
